import { ResolvedUser } from "./ResolvedUser.interface";
import { UserProperties } from "./UserProperties.interface";
export class User {
    constructor({
        id,
        firstName,
        lastName,
        email,
        externalStatus,
        homeOrganizationId,
        userGroupIds,
        created,
        lastLoggedIn,
        isLocalInSSO,
        isVirtual,
        properties,
        createdBy,
        principalUsers
    }: {
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        externalStatus: string;
        homeOrganizationId: string;
        userGroupIds: string[];
        created: Date;
        lastLoggedIn: Date;
        isLocalInSSO: boolean;
        isVirtual?: boolean;
        properties?: UserProperties[] | undefined;
        createdBy?: ResolvedUser;
        principalUsers?: ResolvedUser[];
    }) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.externalStatus = externalStatus;
        this.homeOrganizationId = homeOrganizationId;
        this.userGroupIds = userGroupIds;
        this.groupCount = this.userGroupIds.length;
        this.created = created;
        this.lastLoggedIn = lastLoggedIn;
        this.isLocalInSSO = isLocalInSSO;
        this.isVirtual = isVirtual ?? false;
        this.properties = properties;
        this.createdBy = createdBy;
        this.principalUsers = principalUsers;
    }

    id: string;
    firstName: string;
    lastName: string;
    email: string;
    externalStatus: string;
    homeOrganizationId: string;
    groupCount: number;
    userGroupIds: string[];
    created: Date;
    lastLoggedIn: Date;
    isLocalInSSO: boolean;
    isVirtual: boolean;
    properties?: UserProperties[];
    // Only returned by the single-user read endpoint, and only for virtual teammates.
    createdBy?: ResolvedUser;
    // Only returned by the single-user read endpoint, and only for virtual teammates.
    principalUsers?: ResolvedUser[];
}
